export const compareEqualObjects = (origin, target, visited = new Set()) => {
  if (origin === target) {
    return true;
  } 
  
  // Handle Date objects
  if (origin instanceof Date && target instanceof Date) {
    // Both dates are invalid (NaN)
    if (isNaN(origin.getTime()) && isNaN(target.getTime())) {
      return true;
    }
    return origin.getTime() === target.getTime();
  } 
  
  // Handle null, undefined, or non-object types
  if (
    !origin ||
    !target ||
    (typeof origin !== 'object' && typeof target !== 'object')
  ) {
    return origin === target;
  }
  
  // Check if either is not an object
  if (typeof origin !== 'object' || typeof target !== 'object') {
    return false;
  }
  
  // Handle circular references
  const originKey = origin;
  const targetKey = target;
  if (visited.has(originKey) || visited.has(targetKey)) {
    return true; // Assume equal to avoid infinite recursion
  }
  visited.add(originKey);
  visited.add(targetKey);
  
  // Check prototype differences
  if (Object.getPrototypeOf(origin) !== Object.getPrototypeOf(target)) {
    return false;
  }
  
  // Compare object properties
  const keys = Object.keys(origin);
  if (keys.length !== Object.keys(target).length) {
    return false;
  }
  
  const result = keys.every((key) => compareEqualObjects(origin[key], target[key], visited));
  
  // Clean up visited set for this comparison branch
  visited.delete(originKey);
  visited.delete(targetKey);
  
  return result;
};

export const objectIsEmpty = (object) => !!Object.keys(object).length;

export const areEqualObjects = (initObj = {}, compareObj = {}) => {
  // Return false if either parameter is not an object (including null)
  if (typeof initObj !== 'object' || typeof compareObj !== 'object' || 
      initObj === null || compareObj === null) {
    return false;
  }
  
  return JSON.stringify(initObj) === JSON.stringify(compareObj);
};

export const reverseObjectProperties = (sourceObj) =>
  Object.entries(sourceObj)
    .map(([key, value]) => [value, key])
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
